import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';

const QUERY = '(min-width: 1536px)';

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isDesktop;
}

export function MobileNavMenu({ children, label, title = 'Menu', testId = 'mobile-menu-btn', icon }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname, location.search]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex items-center gap-2 p-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors text-sm"
        aria-label={`Open ${title}`}
        data-testid={testId}
      >
        {icon || <FaBars className="text-xl" />}
        {label && <span>{label}</span>}
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-[85vw] max-w-xs overflow-y-auto" data-testid={`${testId}-sheet`}>
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
          </SheetHeader>
          <div className="mt-6 flex flex-col items-stretch gap-2 [&>*]:w-full [&>*]:!ml-0 [&>*]:py-3 [&>*]:px-4 [&>*]:text-sm [&>*]:rounded-lg [&>*]:border [&>*]:border-gray-100">
            {children}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
